const areas = [
  { icon: 'ri-settings-3-line', title: 'Mecânica Industrial' },
  { icon: 'ri-drop-line', title: 'Hidráulica Industrial' },
  { icon: 'ri-fire-line', title: 'Soldagem' },
  { icon: 'ri-hammer-line', title: 'Caldeiraria' },
  { icon: 'ri-flashlight-line', title: 'Elétrica Industrial' },
  { icon: 'ri-calendar-schedule-line', title: 'Planejamento' },
  { icon: 'ri-shield-check-line', title: 'Segurança do Trabalho' },
  { icon: 'ri-briefcase-line', title: 'Administrativo' },
  { icon: 'ri-store-2-line', title: 'Comercial' },
  { icon: 'ri-user-star-line', title: 'Banco de Talentos' },
];

export default function AreasSection() {
  return (
    <section className="relative bg-gp-graphite-light py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(232,185,42,0.3) 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Vagas</span>
            <div className="w-12 h-[2px] bg-gp-yellow"></div>
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white uppercase tracking-wider">
            Áreas de <span className="text-gp-yellow">Interesse</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 max-w-6xl mx-auto">
          {areas.map((area, index) => (
            <div
              key={index}
              className="group bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/40 rounded-lg p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:bg-gp-graphite-lighter/30"
            >
              <div className="w-12 h-12 bg-gp-yellow/10 rounded-lg flex items-center justify-center mx-auto mb-3 group-hover:bg-gp-yellow/20 transition-colors duration-300">
                <i className={`${area.icon} text-gp-yellow text-lg w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <p className="text-white text-sm font-semibold uppercase tracking-wider leading-tight">
                {area.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}